import { render, staticRenderFns } from "./KubeSubController.vue?vue&type=template&id=119b7a86&scoped=true&"
import script from "./KubeSubController.vue?vue&type=script&lang=js&"
export * from "./KubeSubController.vue?vue&type=script&lang=js&"
import style0 from "./KubeSubController.vue?vue&type=style&index=0&id=119b7a86&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119b7a86",
  null
  
)

export default component.exports